// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34s4I","colBig":"styles_colBig__3zpyj","colSmall":"styles_colSmall__TKb2L","shopifyNameWrapper":"styles_shopifyNameWrapper__1Cwp5"};